<template>
  <div>
    <!--CONSULTAR INFORMACOES -->
    <transition name="esocial-modal-fade">
      <div
        class="esocial-modal-overlay"
        v-if="boolExibirConsultaProtocolo"
        @click.self="boolExibirConsultaProtocolo = false"
      >
        <div class="esocial-modal esocial-modal--wide">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Consultar Informações no eSocial</span>
            <button class="esocial-modal__close" @click="boolExibirConsultaProtocolo = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <ed-alert class="mb-3">
              <div slot="description">
                Escolha abaixo o que gostaria de consultar diretamente no webservice do eSocial. Essas consultas usam o
                certificado digital da empresa e podem demorar alguns segundos.
              </div>
            </ed-alert>

            <div class="esocial-tabs esocial-tabs--consulta">
              <div
                class="esocial-tabs__item"
                :class="{ 'is-active': tabSelected == 'tab-consulta-protocolo' }"
                @click="tabSelected = 'tab-consulta-protocolo'"
              >
                <i class="fa fa-hashtag"></i>
                <span>Situação do Protocolo</span>
              </div>

              <div
                class="esocial-tabs__item"
                :class="{ 'is-active': tabSelected == 'tab-consulta-recibo' }"
                @click="tabSelected = 'tab-consulta-recibo'"
              >
                <i class="fa fa-file-text-o"></i>
                <span>Informações do Recibo</span>
              </div>

              <div
                class="esocial-tabs__item"
                :class="{ 'is-active': tabSelected == 'tab-consulta-evento-empresa' }"
                @click="tabSelected = 'tab-consulta-evento-empresa'"
              >
                <i class="fa fa-building-o"></i>
                <span>Eventos do Empregador</span>
              </div>

              <div
                class="esocial-tabs__item"
                :class="{ 'is-active': tabSelected == 'tab-consulta-evento-trabalhador' }"
                @click="tabSelected = 'tab-consulta-evento-trabalhador'"
              >
                <i class="fa fa-user-o"></i>
                <span>Eventos do Trabalhador</span>
              </div>
            </div>

            <div class="esocial-tabs-panel">
              <consulta-protocolo
                v-show="tabSelected == 'tab-consulta-protocolo'"
                :lstEmpresa="lstEmpresa"
                :loadingEmpresa="loadingEmpresa"
                :loadingFuncionario="loadingFuncionario"
              />

              <consulta-recibo
                v-show="tabSelected == 'tab-consulta-recibo'"
                :lstEmpresa="lstEmpresa"
                :loadingEmpresa="loadingEmpresa"
                :loadingFuncionario="loadingFuncionario"
              />

              <consulta-evento-empresa
                v-show="tabSelected == 'tab-consulta-evento-empresa'"
                :lstEmpresa="lstEmpresa"
                :loadingEmpresa="loadingEmpresa"
                :loadingFuncionario="loadingFuncionario"
              />

              <consulta-evento-trabalhador
                v-show="tabSelected == 'tab-consulta-evento-trabalhador'"
                :lstEmpresa="lstEmpresa"
                :loadingEmpresa="loadingEmpresa"
                :loadingFuncionario="loadingFuncionario"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--GERAR NOVO LOTE -->
    <GerarLote :parent="this" :showForm="showFormEdit" />
    <Agendamento :showForm="showAgendamento" />
    <EmailLote :parent="this" :showForm="showFormEmail" />
    <Item :showForm="showFormItem" />

    <Processar :formData="formData" :showForm="showFormProcessar" />

    <div class="esocial-toolbar">
      <div class="esocial-toolbar__actions">
        <button class="esocial-search__btn esocial-search__btn--primary" @click="onRegister">
          <i class="fa fa-plus-circle"></i> Gerar Novo Lote
        </button>
        <button
          v-if="$root.$session.validarPacote(30)"
          class="esocial-search__btn"
          @click="boolExibirConsultaProtocolo = !boolExibirConsultaProtocolo"
        >
          <i class="fa fa-search"></i> Consultar Informações
        </button>
      </div>

      <div class="esocial-tabs">
        <div
          class="esocial-tabs__item"
          :class="{ 'is-active': !formFilter.layout }"
          @click="onLayoutTab(null)"
        >
          <i class="fa fa-th-large"></i>
          <span>Todos</span>
        </div>

        <div
          v-for="tabela in lstLayout"
          :key="tabela.id"
          class="esocial-tabs__item"
          :class="{ 'is-active': formFilter.layout == tabela.codigo }"
          @click="onLayoutTab(tabela.codigo)"
        >
          <i class="fa fa-file-code-o"></i>
          <span>{{ tabela.codigo }}</span>
        </div>
      </div>

      <div class="esocial-search">
        <div class="esocial-search__group">
          <div class="esocial-search__input">
            <i class="fa fa-search"></i>
            <input
              type="text"
              v-model="search"
              placeholder="Pesquisar por Lote, Empresa..."
              @keyup.enter="getEsocialLotes(search, 1)"
            />
          </div>
          <button class="esocial-search__btn esocial-search__btn--attached" @click="getEsocialLotes(search, 1)">
            <i class="fa fa-search"></i> Buscar
          </button>
        </div>
        <button class="esocial-search__btn esocial-search__btn--filter" @click="showFilterModal = true">
          <i class="fa fa-filter"></i> Filtrar
          <span class="esocial-search__badge" v-if="filterBadge > 0">{{ filterBadge }}</span>
        </button>
        <button class="esocial-search__btn" @click="showAgendamento = !showAgendamento" title="Rotinas Automáticas">
          <i class="fa fa-clock-o"></i>
        </button>
      </div>
    </div>

    <esocial-tabela
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
      :search="search"
      :onSearch="getEsocialLotes"
      :onDelete="onDelete"
    />

    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="showFilterModal" @click.self="showFilterModal = false">
        <div class="esocial-modal">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Filtrar Resultado</span>
            <button class="esocial-modal__close" @click="showFilterModal = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <ed-form :model="formFilter">
              <ed-input-select
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                label="Empresa"
                v-model="formFilter.id_empresa"
                :items="lstEmpresa"
                :loading="loadingEmpresa"
                @input="getFuncionario"
                @search="getEmpresa"
                clearable
                remote
              />

              <ed-input-select
                class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                label="Trabalhador"
                v-model="formFilter.id_funcionario"
                :items="lstFuncionario"
                :loading="loadingFuncionario"
                @search="getFuncionario"
                clearable
                remote
              />
            </ed-form>
          </div>

          <div class="esocial-modal__footer">
            <button class="esocial-search__btn" @click="onClearFilter(); showFilterModal = false">
              <i class="fa fa-refresh"></i> Limpar
            </button>
            <button
              class="esocial-search__btn esocial-search__btn--filter"
              @click="getEsocialLotes(search, 1); showFilterModal = false"
            >
              <i class="fa fa-filter"></i> Filtrar
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Rest from "common/rest";
import { EdForm, EdInputSelect, EdAlert } from "template";
import ConsultaProtocolo from "./includes/consulta-protocolo.vue";
import ConsultaRecibo from "./includes/consulta-recibo.vue";
import ConsultaEventoTrabalhador from "./includes/consulta-evento-trabalhador.vue";
import ConsultaEventoEmpresa from "./includes/consulta-evento-empresa.vue";
import EsocialTabela from "../includes/tabela";

import GerarLote from "./gerar";
import EmailLote from "./email/index";
import Processar from "./processar/index";
import Item from "./item/index";
import Agendamento from "../includes/agendamento";

export default {
  name: "esocial-lotes",
  mixins: [Rest],
  components: {
    EsocialTabela,
    GerarLote,
    EmailLote,
    Processar,
    Item,
    Agendamento,
    EdForm,
    EdInputSelect,
    EdAlert,
    ConsultaProtocolo,
    ConsultaRecibo,
    ConsultaEventoTrabalhador,
    ConsultaEventoEmpresa,
  },
  provide() {
    return {
      formData: this.formData,
      getEmpresa: this.getEmpresa,
      getFuncionario: this.getFuncionario,
      getLayout: this.getLayout,
      parent: this,
    };
  },
  data() {
    return {
      response: {},
      pagination: {},
      formData: {},
      search: null,
      showFilterModal: false,
      tableHead: [
        {
          key: "lote",
          sortable: true,
          width: "150px",
          bold: true,
          label: "Lote",
        },
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "layout",
          sortable: true,
          label: "Layout",
        },
        {
          key: "eventos",
          show_eventos: true,
          label: "Eventos",
        },
        {
          key: "arquivo",
          show_arquivo: true,
          label: "Arquivo",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
          info: "Data da última alteração deste lote: eventos adicionados/removidos, geração do arquivo XML ou atualização do status de processamento.",
        },
      ],
      tableData: [],
      lstEmpresa: [],
      lstFuncionario: [],
      lstLayout: [],
      formFilter: {
        id_empresa: null,
        id_funcionario: null,
        layout: null,
      },
      showFormEdit: false,
      showAgendamento: false,
      showFormEmail: false,
      showFormProcessar: false,
      loadingTable: false,
      loadingEmpresa: false,
      loadingFuncionario: false,
      boolExibirConsultaProtocolo: false,
      showFormItem: false,
      filterBadge: 0,
      tabSelected: "tab-consulta-protocolo",
    };
  },

  created() {
    this.getEsocialLotes(this.$route.params.lote);
  },

  mounted() {
    this.getEmpresa();
    this.getLayout();
  },

  methods: {
    onRegister(init) {
      this.showFormEdit = !this.showFormEdit;
    },

    onEmail(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout,
      };
      this.showFormEmail = !this.showFormEmail;
    },

    onItem(data) {
      this.formData = Object.assign(
        {
          id: data.id,
          lote: data.lote,
          layout: data.layout,
          avulso: data.avulso,
        },
        {}
      );
      this.showFormItem = !this.showFormItem;
    },

    onProcessar(data) {
      this.formData = {
        id: data.id,
        lote: data.lote,
        layout: data.layout,
      };
      this.showFormProcessar = !this.showFormProcessar;
    },

    onDelete(data) {
      var self = this;

      this.$confirm(
        "O sistema vai excluir " +
          data.length +
          " registro(s). Deseja prosseguir?",
        "Atenção",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        self.loadingTable = true;

        this.post("esocial/lotes/deletar", { ids: data }).then((result) => {
          result = result[0];

          self.loadingTable = false;

          if (result.status == 200) {
            self.getEsocialLotes();
            self.edMsg("Registo excluido com sucesso");
          }
        });
      });
    },

    onClearFilter() {
      this.formFilter.id_empresa = null;
      this.formFilter.id_funcionario = null;

      this.getEsocialLotes(this.search, 1);
    },

    onLayoutTab(codigo) {
      this.formFilter.layout = codigo;
      this.getEsocialLotes(this.search, 1);
    },

    getLayout(_search) {
      this.lstLayout = [];

      this.get("esocial/tabelas/conteudo/9", { search: _search }).then(
        (result) => {
          result = result[0];

          if (result.status == 200) {
            this.lstLayout = result.data.data;
          }
        }
      );
    },

    getEmpresa(_search) {
      this.lstEmpresa = [];
      this.loadingEmpresa = true;

      this.get("/empresa", { search: _search }).then((result) => {
        result = result[0];
        if (result.status == 200) {
          this.lstEmpresa = result.data.data;
        }
        this.loadingEmpresa = false;
      });
    },

    getFuncionario(_search) {
      if (!this.formFilter.id_empresa) return;

      this.lstFuncionario = [];
      this.loadingFuncionario = true;

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, {
        search: _search,
      }).then((result) => {
        result = result[0];
        if (result.status == 200) {
          this.lstFuncionario = result.data.data;
        }
        this.loadingFuncionario = false;
      });
    },

    getEsocialLotes(_search = this.search, _page = this.pagination.current_page) {
      this.loadingTable = true;
      this.response = {};
      this.search = _search;

      this.filterBadge =
        (this.formFilter.id_empresa ? 1 : 0) +
        (this.formFilter.id_funcionario ? 1 : 0);

      this.get("esocial/lotes", {
        page: _page,
        search: _search,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];
        this.response = result;

        this.loadingTable = false;

        if (result.status == 200) {
          this.formataLista(result);
        }
      });
    },

    formataLista(result) {
      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i].fdt =
          arrData[i].empresa.fdt && arrData[i].empresa.fdt.length ? arrData[i].empresa.fdt[0] : null;

        var item = {
          lote: arrData[i].lote,
          empresa: arrData[i].empresa.nome,
          layout: arrData[i].layout,
          eventos: {
            total: arrData[i].total_evento,
            enviado: arrData[i].total_evento_enviado,
            erro: arrData[i].total_evento_erro,
          },
          arquivo: arrData[i].arquivo,
          protocolo: arrData[i].protocolo,
          recibo: arrData[i].recibo,
          updated_at: this.toDate(arrData[i].updated_at, false),
          _data: arrData[i],
          buttons: [
            {
              icon: "fa fa-envelope",
              color: "warning",
              title: "Enviar Lote por Email",
              click: this.onEmail,
            },
          ],
          options: {},
        };

        if (this.$root.$session.validarPacote(30)) {
          item.buttons.push({
            icon: "fa fa-paper-plane",
            color: "success",
            title: "Processar Lote",
            click: this.onProcessar,
          });
        }

        if (true) {
          item.buttons.push({
            icon: "fa fa-th-list",
            color: "primary",
            title: "Visualizar items no arquivo",
            click: this.onItem,
          });
        }

        tableData.push(item);
      }

      this.tableData = tableData;
      this.pagination = result.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  flex-wrap: nowrap;
}

.esocial-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.esocial-tabs {
  display: flex;
  align-items: stretch;
  gap: 2px;
  background: #f0f1f3;
  border-radius: 8px;
  padding: 3px;
  height: 36px;
  flex: 1 1 260px;
  min-width: 0;
  overflow-x: auto;

  &--consulta {
    flex: none;
    width: 100%;
    margin-bottom: 18px;
  }
}

.esocial-tabs-panel {
  min-height: 260px;
}

.esocial-tabs__item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.15s, color 0.15s, box-shadow 0.15s;

  i {
    font-size: 11px;
  }

  &:hover:not(.is-active) {
    color: #374151;
  }

  &.is-active {
    background: #fff;
    color: #1f2329;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
}

.esocial-search {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex: 1 1 320px;
  min-width: 0;
  justify-content: flex-end;
}

.esocial-search__group {
  display: flex;
  align-items: stretch;
  height: 36px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #d0d4d9;
  border-radius: 8px;
  overflow: hidden;
  flex: 1 1 auto;
  min-width: 160px;
  transition: border-color 0.15s;

  &:focus-within {
    border-color: #09f;
  }
}

.esocial-search__input {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  padding: 0 12px;
  flex: 1 1 auto;
  min-width: 0;

  i {
    color: #9aa0a8;
    font-size: 12px;
  }

  input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 12px;
    color: #1f2329;
    width: 100%;
    height: 100%;

    &::placeholder {
      color: #9aa0a8;
    }
  }
}

.esocial-search__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--attached {
    height: 100%;
    border: none;
    border-left: 1px solid #d0d4d9;
    border-radius: 0;
    background: #f7f8f9;

    &:hover {
      background: #eef0f2;
    }
  }

  &--filter {
    position: relative;
    color: rgb(168, 121, 31);
    border-color: #f0dfb8;
    background: #fdf8ee;

    &:hover {
      background: #f5e6c3;
    }
  }

  &--primary {
    color: #fff;
    border-color: rgb(168, 121, 31);
    background: rgb(168, 121, 31);

    &:hover {
      background: rgb(148, 106, 27);
    }
  }
}

.esocial-search__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: rgb(168, 121, 31);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;

  &--wide {
    width: 90%;
    max-width: 980px;
  }
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?807460c8